<ng-container *transloco="let t; prefix: 'tasks.taskDetail.products.editDialog.deleteConfirm'">
  <div mat-dialog-title class="dialog-header">
    <span class="dialog-title headline-small">{{ t('title') }}</span>
  </div>

  <mat-dialog-content class="dialog-content">
    <span class="body-medium">{{ t('message') }}</span>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button matButton type="button" [mat-dialog-close]="false">
      {{ t('cancel') }}
    </button>
    <button matButton="filled" type="button" [mat-dialog-close]="true">
      {{ t('confirm') }}
    </button>
  </mat-dialog-actions>
</ng-container>
